import firebase from "./firebase";
import { AUTH_PROVIDERS } from "./AuthService";

export default firebase;

export { AUTH_PROVIDERS };
